module.exports = __webpack_public_path__ + "img/gulp.ef7b0ab1.svg";